import { useCacheSlice } from '../hooks'

export type Task = {
  task: string
  task_description: string
  task_group: string
}

export function useTasksCache() {
  const { data, isLoading } = useCacheSlice('tasks')
  const tasks = data as Task[]
  return { tasks, isLoading }
}
